module.exports = __webpack_public_path__ + "img/xrp.7b59a901.png";